import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressDetailsComponent } from './components/address-details/address-details.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EmojiFlagPipe } from '@shared/filters/emoji-flag.pipe';
import { ResendEmailConfirmationEffects } from './effects/resend-email-confirmation.effects';
import { AddressAutocompleteDirective } from './directives/address-autocomplete.directive';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { RouterModule } from '@angular/router';
import { ContactsContainerComponent } from './containers/contacts-container/contacts-container.component';
import { ContactItemComponent } from './components/contact-item/contact-item.component';
import { ContactRoleComponent } from './components/contact-role/contact-role.component';
import { AddEditContactComponent } from './components/add-edit-contact/add-edit-contact.component';
import { SharedModule } from '@shared/shared.module';
import { EsetSharedModule } from '@eset/eset-shared';
import { ContactRolesContainerComponent } from './containers/contact-roles-container/contact-roles-container.component';

@NgModule({
  declarations: [
    AddressDetailsComponent,
    AddressAutocompleteDirective,
    ContactsContainerComponent,
    ContactRolesContainerComponent,
    AddEditContactComponent,
    ContactItemComponent,
    ContactRoleComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    IonicModule,
    ReactiveFormsModule,
    EmojiFlagPipe,
    NgxMaskPipe,
    NgxMaskDirective,
    SharedModule,
    EsetSharedModule,
    EffectsModule.forFeature([ResendEmailConfirmationEffects]),
  ],
  exports: [
    AddressDetailsComponent,
    ContactsContainerComponent,
    AddEditContactComponent,
    ContactRolesContainerComponent,
  ],
})
export class CustomersSharedModule {}
